//http://mtp.kugou.net/clientmanage_v2/pms/show?type=show_record&id=34808#terminal_11
//主动搜索，认领对应歌手，复制GetSingerList的逻辑
//新接口：通过singerid搜索歌手
import React, { useEffect, useState, Fragment } from 'react'

import './index.scss'

import Dialog from '../../../Components/Dialog'

import history from '../../../History'

import e from '../../../Utils/Event'

export default function GetSingerList(props) {

  //提示弹窗
  const [showTipsDialog, setShowTipsDialog] = useState(false)
  const [tipsContent, setTipsContent] = useState('')

  const errSrc = '//y.gtimg.cn/music/photo_new/T017M000000Cmb6i28tb7c.png'

  const statusMap = {
    0: {
      text: '立即认领',
      to: '/enter/',
    },
    1: {
      text: '已入驻'
    }
  }

  function goGet(data) {
    let { singerPic, platform, singerName, singerId, tmeSingerId, settleStatus, reason,
    canClaim, type, area, identity, genre, introduce, kugouSingerId } = data
    let path = statusMap[settleStatus].to
    if (reason) {
      return /* path ? window.$Msg(reason) :  */showTips(reason)
    } else {
      if (!path) return;
    }
    window.$getUserStatus(({ status }) => {
      //非机构：kugouSingerId（source ：1），机构歌手：tmeSingerId（source：4）
      let searchId = platform === 4 ? tmeSingerId : singerId;
      let objToPass = {
        name: singerName,
        pic: singerPic || errSrc,
        id: searchId,
        status,
        platform
      }
      if (canClaim && platform === 4) {
        //tme机构认领需要禁止编辑的
        Object.assign(objToPass, {
          type,
          area,
          identity,
          genre,
          introduce
        })
      }
      check({ id: searchId, platform }, () => {
        localStorage.removeItem(`enter-musician-${window.$userInfo.userid}`)
        let realPath = path + window.encodeURIComponent(JSON.stringify(objToPass))
        history.go(realPath)
      })
    })

  }

  function check({ id, platform }, callback) {
    window.$req('checkSingerCanGet', { id, platform }).then(res => {
      let data = res.data
      if (data.result) {
        callback && callback()
      } else {
        showTips(data.resultInfo)
        // window.$Msg(data.resultInfo)
      }
    }).catch(e => {
      window.$req('服务异常，请稍后重试')
    })
  }

  function getSingerList(name, singerid) {
    e.emit('loading', true)
    window.$req('searchSingerById', { singerId: singerid }).then(res => {
      e.emit('loading', false)
      let data = res.data;
      let result = [];
      
      if(data){
        result.push(data);
        //机构歌手: tmesingerid不为空且大于0
        if ( data.tmeSingerId && data.tmeSingerId > 0 ){
          data.platform = 4;
        }else{
          data.platform = 1;
        }
      }

      if( result.length ){
        let hasSinger = false;
        result.map((item)=>{
          if( /* item.singerName == props.singerName && */ item.kugouSingerId == props.singerId ){
            hasSinger = true;
            goGet(item);
          }
        })
        if(!hasSinger){//未查询到
          goEnter();
        }
      }else{
        goEnter();
      }
    }).catch(err => {
      e.emit('loading', false)
      if (err.message) {
        window.$Msg(err.message)
      }
    })
  }

  function goEnter() {
    window.$getUserStatus(({ status }) => {
      localStorage.removeItem(`enter-musician-${window.$userInfo.userid}`)
      history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
    })
  }

  //提示弹窗
  function showTips(word) {
    setTipsContent(word)
    setShowTipsDialog(true)
  }

  function closeDiloag(){
    setShowTipsDialog(false)
    if (window.LC.isIOS) {
      window.LC.mobileCall(158, { type: 1 })
    } else {
      window.LC.mobileCall(158, { type: 2 })
    }
  }

  useEffect(() => {
    getSingerList(props.singerName, props.singerId)
  }, [])

  return (<div className="SearchSingerClaim">
    <Dialog title="提示" visible={showTipsDialog} setVisible={setShowTipsDialog} btns={[{ text: '知道了', fn: () => closeDiloag() }]}>
      <div className="getSingerListTipsContent">{tipsContent}</div>
    </Dialog>
  </div>)
}